function getStructureClient(client) {
  return {
    id: client.id,
    email: client.email,
    nomToDisplay: (client.nomCommercial + ' - ' + client.email),
    nom: client.nomCommercial,
    prenom: '',
    archive: client.archive,
  };
}

export default function getInfoClientsMail(intervenants, title) {
  const listOfClients = {
    nomCommercial: title ?? null,
    contacts: intervenants
      .filter((i => i.tiers?.email))
      .map((i) => getStructureClient(i.tiers)),
  };

  return listOfClients;
}
